import qs from 'qs';
import { api } from '../../routes/api';

export const activateCovenant = async params => {
  const response = await api.post(`/app/covenant/enable`, qs.stringify(params));
  return response.data;
}


// WEBPACK FOOTER //
// ./src/pages/Covenant/services.js